import React from "react";
import { Alert, Heading, SelectOption } from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";
import FormField from "../../Common/FormField";
import SelectField from "../../Common/SelectField";
import Upload from "../../Import/Upload";
import { COUNTRY_NAME, COUNTRIES_WITH_CITY_FIELD, TYPE_OF_DOCUMENT } from "../../Common/constants";

const PASecurityLoginSection = ({ formik, isModifyUser, country }) => {
  const { t } = useTranslation("common");

  return (
    <section id="pa-security-login">
      <div className="row">
        <div className="col-xs-12">
          <Heading
            level={4}
            className="heading-4 dls-deep-blue pad-2-t pad-2-b"
          >
            {isModifyUser
              ? t("newUserUK.modifyPASecurityForLogin")
              : t("newUserUK.newPASecurityForLogin")}
          </Heading>
        </div>
      </div>
      <div className="row">
        {COUNTRIES_WITH_CITY_FIELD(t).includes(country) && (
          <FormField
            id="password"
            name="password"
            label={t("newuser.passwordLabel")}
            colmd="col-md-3"
            type="text"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && formik.errors.password}
            tooltipText={t("newUserUK.passwordTooltip")}
          />
        )}
        <FormField
          id="verificationPin"
          name="verificationPin"
          label={t("newuser.verificationPinLabel")}
          colmd="col-md-3"
          value={formik.values.verificationPin}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.verificationPin && formik.errors.verificationPin
          }
          tooltipText={t("newUserUK.verificationPinTooltip")}
        />
        <FormField
          id="memorableDate"
          name="memorableDate"
          label={t("newuser.memorableDateLabel")}
          colmd="col-md-3"
          value={formik.values.memorableDate}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={4}
          error={formik.touched.memorableDate && formik.errors.memorableDate}
          tooltipText={t("newUserUK.memorableDateTooltip")}
        />
        <FormField
          id="clueMemorableDate"
          name="clueMemorableDate"
          label={t("newuser.memorableDateClue")}
          colmd="col-md-3"
          value={formik.values.clueMemorableDate}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.clueMemorableDate && formik.errors.clueMemorableDate
          }
        />
        {country === t(`access.INTERNATIONALEUROCARD`) && (
          <FormField
            id="photoIdNumber"
            name="photoIdNumber"
            label={t("newuser.photoIdNumberLabel")}
            colmd="col-md-3"
            value={formik.values.photoIdNumber}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={formik.touched.photoIdNumber && formik.errors.photoIdNumber}
          />
        )}
      </div>
      {country === t(`access.INTERNATIONALEUROCARD`) && (
        <div className="row">
          <SelectField
            id="typeOfDocument"
            name="typeOfDocument"
            label={t("newuser.typeOfDocumentLabel")}
            colmd="col-md-3"
            value={formik.values.typeOfDocument}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.typeOfDocument && formik.errors.typeOfDocument
            }
          >
            <SelectOption value="" />
            {TYPE_OF_DOCUMENT.map((document) => (
              <SelectOption
                key={document}
                value={document}
                data-label={document}
              >
                {document}
              </SelectOption>
            ))}
          </SelectField>
          <FormField
            id="photoExpiryDate"
            name="photoExpiryDate"
            label={t("newuser.photoExpiryDateLabel")}
            colmd="col-md-3"
            value={formik.values.photoExpiryDate}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={
              formik.touched.photoExpiryDate && formik.errors.photoExpiryDate
            }
          />
          {country === t(`access.INTERNATIONALEUROCARD`) && (
            <div className="col-md-12">
              <Upload
                isModifyUser={isModifyUser}
                country={COUNTRY_NAME.IEC}
                getFile={(files) => formik.setFieldValue("paScreeningFiles", files)}
                files={formik.values.paScreeningFiles || []}
              />
              {!isModifyUser &&
                formik.touched.paScreeningFiles &&
                formik.errors.paScreeningFiles &&
                formik.values.paScreeningFiles?.length === 0 && (
                  <Alert status="error">
                    {t("newuser.typeOfDocumentRequired")}
                  </Alert>
                )}
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default PASecurityLoginSection;
